module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("\n\t\t" + _vm._s(_vm.content) + "\n\t")]), _vm._v(" "), _c('NbBtnDropdown', {
    attrs: {
      "name": "自定义dropdown",
      "size": "sm",
      "color": "primary"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hello($event)
      }
    }
  }, [_vm._v("你好")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.world($event)
      }
    }
  }, [_vm._v("世界")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v("\n\t\t\t只需要在NbBtnDropdown中放入一个ul即可。\n\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tsize(选填)：默认中等大小，可填 sm或者lg\n\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tcolor(选填): 默认default，可填 info,success,primary,warning,danger,white,default\n\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t绑定事件，只需在 li下的a上绑定 @click.prevent=\"hello\" 即可\n\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t如果你希望点击了a之后，下拉单不自动收缩，那么@click.prevent.stop=\"hello\" 即可\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-95ed7e2e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/wheel/NbBtnDropdownDemo.vue
// module id = 1013
// module chunks = 1